document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  var PROXY_URL = 'https://groq-proxy.francisco-zeising.workers.dev';

  document.querySelectorAll('.nt-tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var tabId = btn.dataset.tab;
      document.querySelectorAll('.nt-tab-btn').forEach(function (b) {
        b.classList.toggle('active', b.dataset.tab === tabId);
      });
      document.querySelectorAll('.nt-tab-panel').forEach(function (panel) {
        panel.classList.toggle('active', panel.dataset.panel === tabId);
      });
    });
  });

  async function callGeminiProxy(systemInstruction, userText) {
    var response = await fetch(PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ systemInstruction: systemInstruction, userText: userText }),
    });
    if (!response.ok) throw new Error('HTTP ' + response.status);
    var data = await response.json();
    return data.text || 'Lo siento, no pude generar una respuesta.';
  }

  var qaBtn = document.getElementById('nt-qa-btn');
  if (qaBtn) {
    qaBtn.addEventListener('click', async function () {
      var question   = document.getElementById('nt-ia-question').value.trim();
      var resultDiv  = document.getElementById('nt-qa-result');
      var loadingDiv = document.getElementById('nt-qa-loading');
      if (!question) return;
      resultDiv.style.display  = 'none';
      loadingDiv.style.display = 'block';
      var systemPrompt = 'Eres un ingeniero experto en la Norma Térmica chilena vigente (Decreto 15 plenamente activo desde finales de 2025). Hoy es 2026. Responde dudas asumiendo que la ley YA aplica para todos los permisos nuevos. Sé didáctico, directo y breve (máximo 2 párrafos). Usa español de Chile.';
      try {
        var text = await callGeminiProxy(systemPrompt, question);
        resultDiv.innerHTML = '<p>' + text.replace(/\n/g, '<br>') + '</p>';
      } catch (e) {
        resultDiv.innerHTML = '<p style="color:#ef4444">Error de conexión. Intenta de nuevo.</p>';
      } finally {
        loadingDiv.style.display = 'none';
        resultDiv.style.display  = 'block';
      }
    });
  }

  var checklistBtn = document.getElementById('nt-checklist-btn');
  if (checklistBtn) {
    checklistBtn.addEventListener('click', async function () {
      var city       = document.getElementById('nt-ia-city').value;
      var resultDiv  = document.getElementById('nt-checklist-result');
      var loadingDiv = document.getElementById('nt-checklist-loading');
      if (!city) { alert('Selecciona una ciudad primero.'); return; }
      resultDiv.style.display  = 'none';
      loadingDiv.style.display = 'block';
      var systemPrompt = 'Eres un asesor técnico inmobiliario. Estamos en 2026 y la Norma Térmica (Decreto 15) es 100% obligatoria. Te darán una ciudad chilena. Genera 4 preguntas directas que un comprador debe hacerle a la constructora sobre cómo el proyecto cumple la norma vigente para el clima de ESA ciudad (sobre aislación, ventanas, hermeticidad y ventilación). Devuelve HTML usando <ul> y <li>. Resalta la pregunta en <strong>.';
      try {
        var html  = await callGeminiProxy(systemPrompt, 'Ciudad: ' + city);
        var clean = html.replace(/html|```/g, '');
            resultDiv.innerHTML = '<h4 style="font-weight:700;margin-bottom:0.5rem">Checklist para ' + city + ':</h4>' + clean;
  } catch (e) {
    resultDiv.innerHTML = '<p style="color:#ef4444">Error de conexión. Intenta de nuevo.</p>';
  } finally {
    loadingDiv.style.display = 'none';
    resultDiv.style.display  = 'block';
  }
});
}
// --- Sticky Bar ---
  var stickyBar = document.getElementById('nt-sticky-bar');
  var stickyClose = document.getElementById('nt-sticky-close');

  if (stickyBar) {
    function checkScroll() {
      if (window.scrollY > 400) {
        stickyBar.classList.add('visible');
      }
    }
    window.addEventListener('scroll', checkScroll);
    setTimeout(checkScroll, 500);

    if (stickyClose) {
      stickyClose.addEventListener('click', function () {
        stickyBar.classList.remove('visible');
        window.removeEventListener('scroll', checkScroll);
      });
    }
  }

});  